"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const angular_1 = __importDefault(require("angular"));
var XucDirectoryEventType;
(function (XucDirectoryEventType) {
    XucDirectoryEventType["Phone"] = "phone";
    XucDirectoryEventType["Video"] = "video";
})(XucDirectoryEventType || (XucDirectoryEventType = {}));
function XucDirectory($rootScope, XucPhoneHintService, XucLink, $log, $q, XucVideoEventManager, Broadcaster) {
    var searchResult = [];
    var contactSheet = [];
    var favoriteContactSheet = [];
    var favorites = [];
    var headers = [];
    var searchTerm = null;
    var isSearching = false;
    var displayNameRequests = new Map();
    var displayNamesCache = new Map();
    var Cti = window.Cti;
    const _directoryLookup = function (term) {
        searchTerm = term ? term : '';
        isSearching = true;
        Cti.directoryLookUp(searchTerm);
    };
    const _getSearchTerm = function () {
        return searchTerm;
    };
    const _isSearching = function () {
        return isSearching;
    };
    const _onSearchResult = function (result) {
        searchResult = angular_1.default.copy(result.entries);
        isSearching = false;
        _setHeaders(result);
        $rootScope.$broadcast('searchResultUpdated');
    };
    const _onContactSheet = function (result) {
        contactSheet = angular_1.default.copy(result.sheets);
        isSearching = false;
        $rootScope.$broadcast('contactSheetUpdated');
    };
    const _onFavoriteContactSheet = function (result) {
        favoriteContactSheet = angular_1.default.copy(result.sheets);
        isSearching = false;
        $rootScope.$broadcast('favoriteContactSheetUpdated');
    };
    const _onFavorites = function (newFavorites) {
        searchResult = [];
        favorites = angular_1.default.copy(newFavorites.entries);
        _setHeaders(newFavorites);
        $rootScope.$broadcast('favoritesUpdated');
    };
    const _onUserDisplayNameResult = function (result) {
        if (result.displayName) {
            if (displayNameRequests.has(result.userName)) {
                displayNamesCache.set(result.userName, result.displayName);
                displayNameRequests.get(result.userName).resolve(result.displayName);
                displayNameRequests.delete(result.userName);
            }
            else {
                $log.error("Unknown result received, no such username in the map", result.userName);
            }
        }
        else {
            $log.error("Error when retrieving display name ", result);
            displayNameRequests.forEach((values) => {
                values.reject('Failure');
            });
            displayNameRequests.clear();
        }
    };
    const _setHeaders = function (result) {
        headers = angular_1.default.copy(result.headers);
        if (headers.indexOf("Favoris") != -1) {
            headers.splice(-3, 2);
        }
    };
    const _onFavoriteUpdated = function (update) {
        if (update.action === "Removed" || update.action === "Added") {
            contactSheet.forEach(function (elem) {
                if (elem.sources[0].id === update.contact_id && elem.sources[0].name === update.source) {
                    elem.isFavorite = !elem.isFavorite;
                }
            });
        }
        else {
            $log.log("SERVER ERROR: Favorite update failed: ", update);
        }
        _updateFavorites(update);
        $rootScope.$broadcast('searchResultUpdated');
    };
    const _updateFavorites = function (update) {
        if (update.action === "Removed") {
            var result = _find(favoriteContactSheet, update);
            result.elem.isFavorite = false;
            if (_find(contactSheet, update) === undefined)
                contactSheet.push(result.elem);
            if (result.index >= 0)
                favoriteContactSheet.splice(result.index, 1);
        }
        else if (update.action == "Added") {
            var newFavorite = _find(contactSheet, update);
            if (newFavorite) {
                newFavorite.elem.isFavorite = true;
                favoriteContactSheet.push(newFavorite.elem);
            }
        }
        $rootScope.$broadcast('favoritesUpdated');
        $rootScope.$broadcast('favoriteContactSheetUpdated');
    };
    const _find = function (contacts, update) {
        var result;
        contacts.forEach(function (elem, i) {
            if (elem.sources[0].id === update.contact_id && elem.sources[0].name === update.source) {
                result = { 'elem': elem, 'index': i };
            }
        });
        return result;
    };
    const _getSearchResult = function () {
        return searchResult;
    };
    const _getContactSheetResult = function () {
        return contactSheet;
    };
    const _getFavoriteContactSheet = function () {
        return favoriteContactSheet;
    };
    const _getFavorites = function () {
        return favorites;
    };
    const _clearResults = function () {
        favorites = [];
        searchResult = [];
        searchTerm = null;
        isSearching = false;
        $rootScope.$broadcast('searchResultUpdated');
    };
    const _getHeaders = function () {
        return headers;
    };
    const isNotEmpty = function (array) { return array.length > 0; };
    const _updateStatus = function (event, eventType) {
        let source = [];
        let sourceEvent = "";
        let matchFound = false;
        if (isNotEmpty(searchResult)) {
            source = searchResult;
            sourceEvent = 'searchResultUpdated';
        }
        else if (isNotEmpty(favorites)) {
            source = favorites;
            sourceEvent = 'favoritesUpdated';
        }
        else
            return;
        switch (eventType) {
            case XucDirectoryEventType.Video: {
                let videoEvent = event;
                angular_1.default.forEach(source, function (contact) {
                    if (angular_1.default.isDefined(contact) &&
                        angular_1.default.isArray(contact.entry) &&
                        contact.username === videoEvent.fromUser) {
                        contact.videoStatus = videoEvent.status;
                        matchFound = true;
                    }
                });
                break;
            }
            case XucDirectoryEventType.Phone: {
                let phoneEvent = event;
                angular_1.default.forEach(source, function (contact) {
                    if (angular_1.default.isDefined(contact) &&
                        angular_1.default.isArray(contact.entry) &&
                        contact.entry[1] === phoneEvent.number) {
                        contact.status = phoneEvent.status;
                        matchFound = true;
                    }
                });
                break;
            }
        }
        if (matchFound) {
            Broadcaster.send(sourceEvent);
        }
    };
    const _updateContactStatus = (list, event, eventType, sourceEvent) => {
        switch (eventType) {
            case XucDirectoryEventType.Phone: {
                let phoneEvent = event;
                list.forEach(contact => {
                    if (contact.actions.Call &&
                        isNotEmpty(contact.actions.Call.args) &&
                        contact.actions.Call.args[0] === phoneEvent.number) {
                        contact.status.phone = phoneEvent.status;
                    }
                });
                break;
            }
            case XucDirectoryEventType.Video: {
                let videoEvent = event;
                list.forEach(contact => {
                    if (contact.actions.Video &&
                        isNotEmpty(contact.actions.Video.args) &&
                        contact.actions.Video.args[0] === videoEvent.fromUser) {
                        contact.status.video = videoEvent.status;
                    }
                });
                break;
            }
        }
        Broadcaster.send(sourceEvent);
    };
    const _onEvent = function (event, eventType, updateContactStatusFunc, updateStatusFunc) {
        if (isNotEmpty(contactSheet)) {
            updateContactStatusFunc(contactSheet, event, eventType, 'contactSheetUpdated');
        }
        if (isNotEmpty(favoriteContactSheet)) {
            updateContactStatusFunc(favoriteContactSheet, event, eventType, 'favoriteContactSheetUpdated');
        }
        else {
            updateStatusFunc(event, eventType);
        }
    };
    const _onPhoneHint = function (phoneHint) {
        _onEvent(phoneHint, XucDirectoryEventType.Phone, _updateContactStatus, _updateStatus);
    };
    const _onVideoEvent = function (videoEvent) {
        _onEvent(videoEvent, XucDirectoryEventType.Video, _updateContactStatus, _updateStatus);
    };
    const _getUserDisplayName = (user) => {
        var deferred = $q.defer();
        if (displayNamesCache.has(user)) {
            deferred.resolve(displayNamesCache.get(user));
        }
        else {
            displayNameRequests.set(user, deferred);
            Cti.displayNameLookup(user);
        }
        return deferred.promise;
    };
    XucPhoneHintService.addEventListener($rootScope, _onPhoneHint);
    XucVideoEventManager.subscribeToVideoStatusEvent($rootScope, _onVideoEvent);
    const _init = () => {
        $log.info("Starting XucDirectory service");
        Cti.setHandler(Cti.MessageType.DIRECTORYRESULT, _onSearchResult);
        Cti.setHandler(Cti.MessageType.CONTACTSHEET, _onContactSheet);
        Cti.setHandler(Cti.MessageType.FAVORITECONTACTSHEET, _onFavoriteContactSheet);
        Cti.setHandler(Cti.MessageType.FAVORITES, _onFavorites);
        Cti.setHandler(Cti.MessageType.FAVORITEUPDATED, _onFavoriteUpdated);
        Cti.setHandler(Cti.MessageType.USERDISPLAYNAME, _onUserDisplayNameResult);
        XucLink.whenLoggedOut().then(_unInit);
    };
    const _unInit = () => {
        $log.info("Unloading XucDirectory service");
        displayNameRequests.clear();
        displayNamesCache.clear();
        XucLink.whenLogged().then(_init);
    };
    XucLink.whenLogged().then(_init);
    return {
        directoryLookup: _directoryLookup,
        onSearchResult: _onSearchResult,
        onContactSheet: _onContactSheet,
        onFavoriteContactSheet: _onFavoriteContactSheet,
        onFavorites: _onFavorites,
        onFavoriteUpdated: _onFavoriteUpdated,
        getSearchResult: _getSearchResult,
        getContactSheetResult: _getContactSheetResult,
        getFavorites: _getFavorites,
        clearResults: _clearResults,
        getHeaders: _getHeaders,
        getSearchTerm: _getSearchTerm,
        getFavoriteContactSheet: _getFavoriteContactSheet,
        isSearching: _isSearching,
        getUserDisplayName: _getUserDisplayName,
    };
}
exports.default = XucDirectory;
